// removed by extract-text-webpack-plugin
module.exports = {"icon-group":"ScoreDefinitionLinks__icon-group___iDHMC","icon-link":"ScoreDefinitionLinks__icon-link___237Nn"};